import { render, staticRenderFns } from "./search-results.vue?vue&type=template&id=f35f72de&scoped=true&"
import script from "./search-results.vue?vue&type=script&lang=js&"
export * from "./search-results.vue?vue&type=script&lang=js&"
import style0 from "./search-results.vue?vue&type=style&index=0&id=f35f72de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35f72de",
  null
  
)

export default component.exports